import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { useTheme } from 'styled-components';
import { Icon, Text } from '../../ui';
import { StyledCheckbox, StyledCheckmark, StyledInput, StyledLabel, StyledWrapper, } from './Checkbox.style';
export function Checkbox({ id, label, size = 'Medium', checked = false, disabled = false, onClick, }) {
    const theme = useTheme();
    const [isChecked, setIsChecked] = useState(checked);
    const handleOnClick = useCallback((event) => {
        if (disabled)
            return;
        event.stopPropagation();
        setIsChecked((previous) => {
            const newValue = !previous;
            onClick(newValue, event);
            return newValue;
        });
    }, [onClick, disabled]);
    useEffect(() => {
        setIsChecked(checked);
    }, [checked]);
    return (_jsxs(StyledWrapper, { id: id, onClick: handleOnClick, disabled: disabled, children: [_jsxs(StyledCheckbox, { disabled: disabled, checkboxSize: size, children: [_jsx(StyledInput, { type: "checkbox", checkboxSize: size, checked: isChecked, disabled: disabled, readOnly: true }), _jsx(StyledCheckmark, { children: isChecked && (_jsx(Icon, { name: 'check-selected', color: disabled
                                ? theme.Color.Neutrals.Light
                                : theme.Color.System.Primary, size: size })) })] }), label && (_jsx(StyledLabel, { children: _jsx(Text, { size: "Body", color: disabled ? theme.Color.Neutrals.Gray : theme.Color.Neutrals.Dark, children: label }) }))] }));
}
//# sourceMappingURL=Checkbox.js.map